function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevaAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 322 323",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.063,141.022C10.063,135.464 14.568,130.959 20.125,130.959L150.938,130.959C173.167,130.959 191.188,148.98 191.188,171.209L191.188,251.709C191.188,279.496 168.662,302.022 140.875,302.022L20.125,302.022C14.568,302.022 10.063,297.517 10.063,291.959L10.063,141.022Z",
    style: {
      fill: "rgb(0,127,175)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.344,98.256C55.344,94.088 51.965,90.709 47.797,90.709C43.629,90.709 40.25,94.088 40.25,98.256L40.25,133.475C40.25,137.643 43.629,141.022 47.797,141.022C51.965,141.022 55.344,137.643 55.344,133.475L55.344,98.256Z",
    style: {
      fill: "rgb(0,127,175)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.278,196.219C70.278,190.661 74.783,186.156 80.34,186.156C85.898,186.156 90.403,190.661 90.403,196.219L90.403,216.344C90.403,221.901 85.898,226.406 80.34,226.406C74.783,226.406 70.278,221.901 70.278,216.344L70.278,196.219ZM91.567,256.968C87.448,254.251 85.4,250.752 85.374,246.787C85.473,244.187 86.661,243.072 87.63,242.687C88.681,242.271 90.919,242.157 93.927,244.557L94.068,244.67C97.541,247.443 102.606,251.486 109.292,251.486C109.481,251.486 109.664,251.491 109.843,251.499L110.112,251.512L110.381,251.496C110.481,251.49 110.584,251.487 110.688,251.487L130.813,251.487C133.591,251.487 135.844,253.74 135.844,256.518C135.844,259.298 133.591,261.55 130.813,261.55L110.688,261.55C110.604,261.55 110.521,261.548 110.439,261.543L110.235,261.534L110.029,261.541C109.852,261.548 109.671,261.551 109.485,261.551C102.062,261.551 95.804,259.762 91.567,256.968ZM150.938,186.156C145.38,186.156 140.875,190.661 140.875,196.219L140.875,216.344C140.875,221.901 145.38,226.406 150.938,226.406C156.495,226.406 161,221.901 161,216.344L161,196.219C161,190.661 156.495,186.156 150.938,186.156Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.646,95.01C158.148,90.3 150.812,79.552 150.812,67.046L150.812,50.777C150.812,33.929 164.126,20.272 180.549,20.272L249.877,20.272C266.3,20.272 279.612,33.929 279.612,50.777L279.612,67.046C279.612,83.894 266.3,97.552 249.877,97.552L195.431,97.552L168.614,116.872L168.646,95.01Z",
    style: {
      fill: "rgb(0,127,175)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.666,72.507L220.916,39.929C219.509,37.507 215.837,37.429 214.431,39.929L195.681,72.507C194.275,74.929 196.072,78.054 198.962,78.054L236.384,78.054C239.275,78.054 241.072,75.007 239.666,72.507ZM217.712,65.71C219.666,65.71 221.306,67.351 221.306,69.304C221.306,71.335 219.666,72.897 217.712,72.897C215.681,72.897 214.119,71.335 214.119,69.304C214.119,67.351 215.681,65.71 217.712,65.71ZM214.275,52.819C214.197,52.272 214.666,51.804 215.212,51.804L220.134,51.804C220.681,51.804 221.15,52.272 221.072,52.819L220.525,63.444C220.447,63.991 220.056,64.304 219.587,64.304L215.759,64.304C215.291,64.304 214.9,63.991 214.822,63.444L214.275,52.819Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevaAlert);
export default __webpack_public_path__ + "static/media/reva-alert.20c2aa4e678034feb6f4f89b9b7db9fe.svg";
export { ForwardRef as ReactComponent };